
namespace Gamification.Gamification {
    export class RisorseChecklistColumns {
        static columnsKey = 'Gamification.RisorseChecklist';
    }
}